export class ProfilePicture {
    userId: number;
    base64Image: string | null;
    
  
    constructor(data: Partial<ProfilePicture>) {
      this.userId = data.userId ?? 0;
      this.base64Image = data.base64Image ?? '';
    }
  }
  